/* Napewell sales page: offer cards, delivery estimate, carousel, tabs, sticky bar, final glow, clip stage, therapy cards, price bars, muscle map, comparison reveal, smooth questions. No dependencies. */
(function () {
  if (window.__egLoaded) return;
  window.__egLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function fmt(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* Business days from today, skipping Saturdays and Sundays. */
  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  function dayLabel(d) {
    try {
      return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    } catch (e) {
      return d.toDateString();
    }
  }

  /* ---------- Offer cards ---------- */
  function initOffer(card) {
    var currency = card.dataset.currency;
    var variantSel = card.querySelector('[data-eg-variant]');
    var buy = card.querySelector('[data-eg-buy]');
    var totalEl = card.querySelector('[data-eg-total]');
    var err = card.querySelector('[data-eg-error]');

    function unitPrice() {
      if (variantSel) {
        var opt = variantSel.options[variantSel.selectedIndex];
        return parseInt(opt.dataset.price, 10);
      }
      return parseInt(card.dataset.price, 10);
    }

    function selectedTier() {
      return card.querySelector('.eg-tiers input[type=radio]:checked') || card.querySelector('.eg-tiers input[type=radio]');
    }

    /* The crossed-out price per pillow: the compare-at price while a launch price runs, else the normal price. */
    function unitWas(price) {
      var c = variantSel ? variantSel.options[variantSel.selectedIndex].dataset.compare : card.dataset.compare;
      c = parseInt(c, 10) || 0;
      return c > price ? c : price;
    }

    function update() {
      var price = unitPrice();
      var was1 = unitWas(price);
      card.querySelectorAll('.eg-tier').forEach(function (label) {
        var input = label.querySelector('input');
        var qty = parseInt(input.value, 10) || 1;
        var total = price * qty - (parseInt(input.dataset.discount, 10) || 0);
        var was = was1 * qty;
        var t = label.querySelector('[data-eg-tier-total]');
        var e = label.querySelector('[data-eg-tier-each]');
        if (t) t.textContent = fmt(total, currency);
        if (e) e.textContent = fmt(Math.round(total / qty), currency);
        var w = label.querySelector('[data-eg-tier-was]');
        if (w) { w.textContent = fmt(was, currency); w.hidden = !(was > total); }
        var s = label.querySelector('[data-eg-tier-save]');
        if (s) { s.textContent = 'You save ' + fmt(was - total, currency); s.hidden = !(was > total); }
        label.classList.toggle('is-selected', input.checked);
      });
      var tier = selectedTier();
      var qty = tier ? parseInt(tier.value, 10) || 1 : 1;
      var sum = price * qty - (tier ? parseInt(tier.dataset.discount, 10) || 0 : 0);
      var bump = card.querySelector('[data-eg-bump]');
      if (bump && bump.checked) sum += parseInt(bump.dataset.price, 10) || 0;
      if (totalEl) rollTo(sum);
    }

    /* The button total counts to the new amount when the bundle changes. */
    var shown = null, rollRaf = 0;
    function rollTo(sum) {
      if (shown === null || shown === sum || calm.matches) {
        shown = sum;
        totalEl.textContent = fmt(sum, currency);
        return;
      }
      var from = shown, t0 = 0;
      shown = sum;
      if (rollRaf) window.cancelAnimationFrame(rollRaf);
      if (buy) { buy.classList.remove('is-bump'); void buy.offsetWidth; buy.classList.add('is-bump'); }
      function frame(ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / 450);
        var e = 1 - Math.pow(1 - k, 3);
        totalEl.textContent = fmt(Math.round(from + (sum - from) * e), currency);
        rollRaf = k < 1 ? window.requestAnimationFrame(frame) : 0;
      }
      rollRaf = window.requestAnimationFrame(frame);
    }

    card.addEventListener('change', update);

    if (buy) {
      buy.addEventListener('click', function () {
        var tier = selectedTier();
        var qty = tier ? parseInt(tier.value, 10) || 1 : 1;
        var vid = variantSel ? variantSel.value : card.dataset.variant;
        var items = [{ id: parseInt(vid, 10), quantity: qty }];
        var bump = card.querySelector('[data-eg-bump]');
        if (bump && bump.checked) items.push({ id: parseInt(bump.dataset.variant, 10), quantity: 1 });

        buy.disabled = true;
        buy.classList.add('is-loading');
        if (err) err.hidden = true;

        var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
        fetch(root + 'cart/clear.js', { method: 'POST', headers: headers })
          .then(function () {
            return fetch(root + 'cart/add.js', { method: 'POST', headers: headers, body: JSON.stringify({ items: items }) });
          })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = root + 'checkout';
          })
          .catch(function () {
            buy.disabled = false;
            buy.classList.remove('is-loading');
            if (err) err.hidden = false;
          });
      });
    }

    /* The button leans toward the mouse a little (desktop only). */
    if (buy && finePointer.matches && !calm.matches) {
      buy.addEventListener('pointermove', function (e) {
        var r = buy.getBoundingClientRect();
        buy.style.setProperty('--bx', ((e.clientX - r.left - r.width / 2) * 0.06).toFixed(1) + 'px');
        buy.style.setProperty('--by', ((e.clientY - r.top - r.height / 2) * 0.18).toFixed(1) + 'px');
      });
      buy.addEventListener('pointerleave', function () {
        buy.style.setProperty('--bx', '0px');
        buy.style.setProperty('--by', '0px');
      });
    }

    /* Delivery estimate from the business-day range in Theme settings. */
    var eta = card.querySelector('[data-eg-eta]');
    var min = parseInt(card.dataset.etaMin, 10);
    var max = parseInt(card.dataset.etaMax, 10);
    if (eta && min > 0 && max >= min) {
      var today = new Date();
      eta.querySelector('[data-eg-eta-from]').textContent = dayLabel(addBusinessDays(today, min));
      eta.querySelector('[data-eg-eta-to]').textContent = dayLabel(addBusinessDays(today, max));
      eta.hidden = false;
    }

    update();
  }

  /* ---------- Carousel + thumbnails ---------- */
  function initCarousel(c) {
    var track = c.querySelector('[data-eg-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    if (!track || slides.length < 2) return;
    var media = c.parentElement;
    var thumbs = media ? Array.prototype.slice.call(media.querySelectorAll('[data-eg-thumb]')) : [];

    function current() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function go(i) {
      var n = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
    }
    function mark() {
      var i = current();
      slides.forEach(function (s, k) { s.classList.toggle('is-current', k === i); });
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-eg-thumb'), 10) || 0); });
    });
    var prev = c.querySelector('[data-eg-prev]');
    var next = c.querySelector('[data-eg-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    mark();
  }

  /* ---------- Tabs ---------- */
  function initTabs(wrap) {
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') n = tabs[0];
        if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  }

  /* ---------- Sticky bar (phones) ---------- */
  function initSticky(bar) {
    var targetSel = bar.querySelector('[data-eg-scroll]').getAttribute('data-eg-scroll');
    var first = document.querySelector(targetSel);
    var offers = Array.prototype.slice.call(document.querySelectorAll('[data-eg-offer]'));
    if (!first || !('IntersectionObserver' in window)) return;

    var visible = new Set();
    function refresh() {
      var passedFirst = first.getBoundingClientRect().bottom < 0;
      bar.hidden = !(passedFirst && visible.size === 0);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target);
      });
      refresh();
    });
    offers.forEach(function (o) { io.observe(o); });
    window.addEventListener('scroll', refresh, { passive: true });

    bar.querySelector('[data-eg-scroll]').addEventListener('click', function () {
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------- Final offer: the lamp comes on once, when it scrolls into view ---------- */
  function initGlow(sec) {
    if (!('IntersectionObserver' in window)) { sec.classList.add('is-lit'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { sec.classList.add('is-lit'); io.disconnect(); }
      });
    }, { threshold: 0.35 });
    io.observe(sec);
  }

  /* ---------- Phone clips as a moving background ("stage") ----------
     The active clip plays once, then the next one starts (8 s when a clip can't play).
     Wide screens show all three side by side; phones show one at a time (swipe or tap). */
  function initStage(sec) {
    var panels = Array.prototype.slice.call(sec.querySelectorAll('[data-eg-stage-panel]'));
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('[data-eg-stage-tab]'));
    var btn = sec.querySelector('[data-eg-stage-pause]');
    var cap = sec.querySelector('[data-eg-stage-caption]');
    var n = panels.length;
    if (!n) return;
    var wide = window.matchMedia('(min-width: 990px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var HOLD = 4000;
    var cur = 0, paused = reduce, visible = false, elapsed = 0, last = 0, raf = 0;

    function video(i) { return panels[i] ? panels[i].querySelector('video') : null; }
    function playing(v) { return !!v && !v.paused && !v.ended && v.readyState > 2; }

    function apply() {
      panels.forEach(function (p, i) {
        var v = video(i), on = i === cur;
        p.classList.toggle('is-active', on);
        if (!v) return;
        v.loop = true;
        window.clearTimeout(v.egRest);
        if (visible && !paused && (on || wide.matches)) {
          if (v.preload !== 'auto') v.preload = 'auto';
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
        } else if (visible && !paused && playing(v)) {
          /* Phones: the clip we just left keeps playing while it fades out, then rests until its turn comes back. */
          v.egRest = window.setTimeout(function () { if (i !== cur) v.pause(); }, 1000);
        } else {
          v.pause();
        }
      });
      tabs.forEach(function (t, i) {
        t.setAttribute('aria-pressed', i === cur ? 'true' : 'false');
        var bar = t.querySelector('.eg-stage__bar i');
        if (bar && i !== cur) bar.style.width = i < cur ? '100%' : '0%';
      });
      if (cap && tabs[cur]) {
        var tx = tabs[cur].querySelector('.eg-stage__text');
        cap.textContent = tx ? tx.textContent : '';
      }
      sec.classList.toggle('is-paused', paused);
      if (btn) {
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'Play the videos' : 'Pause the videos');
      }
      last = 0;
      if (raf) window.cancelAnimationFrame(raf);
      raf = visible && !paused ? window.requestAnimationFrame(step) : 0;
    }

    function go(i) {
      cur = (i + n) % n;
      elapsed = 0;
      apply();
    }

    /* Each person's turn lasts half their clip, but never under 4 s (so a 5 s clip and an 8 s clip both get 4 s).
       The clip keeps playing after the cut. */
    function turn() {
      var v = video(cur);
      return v && v.duration ? Math.max(HOLD, v.duration * 500) : HOLD;
    }

    function step(ts) {
      raf = 0;
      if (paused || !visible) return;
      if (last) elapsed += ts - last;
      last = ts;
      var p = elapsed / turn();
      var bar = tabs[cur] && tabs[cur].querySelector('.eg-stage__bar i');
      if (bar) bar.style.width = Math.min(100, p * 100).toFixed(1) + '%';
      if (p >= 1) { go(cur + 1); return; }
      raf = window.requestAnimationFrame(step);
    }

    panels.forEach(function (p, i) {
      p.addEventListener('click', function () { if (wide.matches && i !== cur) go(i); });
    });
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { go(i); });
    });
    if (btn) btn.addEventListener('click', function () { paused = !paused; apply(); });

    var x0 = null, y0 = 0;
    sec.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    sec.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) go(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });

    if (wide.addEventListener) wide.addEventListener('change', apply);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { visible = e.isIntersecting; });
        apply();
      }, { threshold: 0.2 }).observe(sec);
    } else {
      visible = true;
      apply();
    }
  }

  /* ---------- Therapy cards: rise in once, float, tilt toward the pointer; on phones the centred card lights up ---------- */
  function initTherapies(list) {
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-eg-therapy]'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window)) return;

    if (!reduce) {
      list.classList.add('eg-reveal');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          /* The huge top margin also counts it as seen when a jump link skipped past it. */
          if (e.isIntersecting || e.boundingClientRect.top < 0) {
            list.classList.add('is-in'); io.disconnect();
            /* After the entrance, drop the stagger so hover and swipe respond at once. */
            setTimeout(function () { list.classList.remove('eg-reveal'); }, 1800);
          }
        });
      }, { threshold: 0.15, rootMargin: '100000px 0px 0px 0px' });
      io.observe(list);
    }

    list.classList.add('eg-live');
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-active', e.intersectionRatio >= 0.6); });
    }, { root: list, threshold: [0, 0.6, 1] });
    items.forEach(function (it) { io2.observe(it); });

    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    items.forEach(function (it) {
      var card = it.querySelector('[data-eg-tilt]');
      if (!card) return;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.classList.add('is-tilting');
        card.style.setProperty('--ry', ((x - 0.5) * 12).toFixed(2) + 'deg');
        card.style.setProperty('--rx', ((0.5 - y) * 10).toFixed(2) + 'deg');
        card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      });
      card.addEventListener('pointerleave', function () {
        card.classList.remove('is-tilting');
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- Therapy cards: the text rolls down over the card (hover on desktop, tap or Enter elsewhere) ---------- */
  function initMore(btn) {
    if (btn.dataset.egBound) return;
    btn.dataset.egBound = '1';
    var card = btn.closest('.eg-therapy__card');
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      card.classList.toggle('is-open', open);
    });
    /* Moving the mouse away closes a card that was opened by clicking, so hover stays the main gesture. */
    card.addEventListener('mouseleave', function () {
      if (!finePointer.matches) return;
      btn.setAttribute('aria-expanded', 'false');
      card.classList.remove('is-open');
    });
  }

  /* ---------- Price comparison: the two bars grow once, when they come into view ---------- */
  function initSave(box) {
    if (box.dataset.egBound || calm.matches || !('IntersectionObserver' in window)) return;
    box.dataset.egBound = '1';
    box.classList.add('eg-anim');
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      window.requestAnimationFrame(function () { box.classList.add('is-on'); });
    }, { threshold: 0.35, rootMargin: '100000px 0px 0px 0px' });
    io.observe(box);
  }

  /* ---------- Muscle map: points over the photo + the list beside it ---------- */
  function initMap(map) {
    if (map.dataset.egBound) return;
    map.dataset.egBound = '1';
    var spots = Array.prototype.slice.call(map.querySelectorAll('[data-eg-map-spot]'));
    var btns = Array.prototype.slice.call(map.querySelectorAll('[data-eg-map-btn]'));
    var n = btns.length, cur = 0, timer = 0, auto = !calm.matches;
    if (!n) return;

    /* Seven vertebrae (C1-C7) placed along the neck curve. */
    var curve = map.querySelector('[data-eg-map-curve]');
    var verts = map.querySelector('[data-eg-map-verts]');
    if (curve && verts && curve.getTotalLength) {
      var len = curve.getTotalLength();
      for (var i = 0; i < 7; i++) {
        var at = len * (i + 0.5) / 7;
        var p = curve.getPointAtLength(at);
        var q = curve.getPointAtLength(Math.min(len, at + 1));
        var ang = Math.atan2(q.y - p.y, q.x - p.x) * 180 / Math.PI + 90;
        var r = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        r.setAttribute('x', '-17');
        r.setAttribute('y', '-9');
        r.setAttribute('width', '34');
        r.setAttribute('height', '18');
        r.setAttribute('rx', '7');
        r.setAttribute('transform', 'translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ') rotate(' + ang.toFixed(1) + ')');
        r.style.setProperty('--v', i);
        verts.appendChild(r);
      }
    }

    function show(i, user) {
      cur = (i + n) % n;
      btns.forEach(function (b, k) {
        var on = k === cur;
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        b.parentElement.classList.toggle('is-active', on);
        var d = document.getElementById(b.getAttribute('aria-controls'));
        if (d) d.hidden = !on;
      });
      spots.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
      /* The curve point also lights up the seven vertebrae. */
      map.classList.toggle('is-curve', /curve|lordosis|C1/i.test(btns[cur].textContent));
      if (user && timer) { window.clearInterval(timer); timer = 0; }
      if (user) auto = false;
    }
    btns.forEach(function (b, k) { b.addEventListener('click', function () { show(k, true); }); });
    spots.forEach(function (s, k) { s.addEventListener('click', function () { show(k, true); }); });
    show(0, false);

    /* On wide screens, while it's on screen and nobody has clicked yet, it steps through the points by itself.
       (Not on phones: the list sits under the photo there, and opening items by itself would move the page.) */
    if (!auto || !window.matchMedia('(min-width: 990px)').matches || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var vis = entries[0].isIntersecting;
      if (vis && auto && !timer) {
        timer = window.setInterval(function () { show(cur + 1, false); }, 5200);
      } else if (!vis && timer) {
        window.clearInterval(timer);
        timer = 0;
      }
    }, { threshold: 0.4 }).observe(map);
  }

  /* ---------- Comparison: the Napewell column lights up, then the ticks draw in row by row ---------- */
  function initCompare(wrap) {
    if (calm.matches || !('IntersectionObserver' in window)) return;
    wrap.querySelectorAll('tbody tr').forEach(function (tr, i) { tr.style.setProperty('--r', i); });
    wrap.classList.add('eg-anim');
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      if (e.isIntersecting || e.boundingClientRect.top < 0) { wrap.classList.add('is-on'); io.disconnect(); }
    }, { threshold: 0.3, rootMargin: '100000px 0px 0px 0px' });
    io.observe(wrap);
  }

  /* ---------- Questions open and close smoothly ---------- */
  function initFaq(d) {
    var sum = d.querySelector('summary');
    var body = d.querySelector('.eg-faq__answer');
    if (!sum || !body || !body.animate || d.dataset.egFaq) return;
    d.dataset.egFaq = '1';
    var anim = null;
    sum.addEventListener('click', function (e) {
      if (calm.matches) return;
      e.preventDefault();
      if (anim) { anim.cancel(); anim = null; }
      body.style.overflow = 'hidden';
      var pad = getComputedStyle(body).paddingBottom;
      if (!d.open) {
        d.open = true;
        var h = body.offsetHeight;
        anim = body.animate([{ height: '0px', paddingBottom: '0px', opacity: 0 }, { height: h + 'px', paddingBottom: pad, opacity: 1 }],
          { duration: 340, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' });
        anim.onfinish = function () { anim = null; body.style.overflow = ''; };
      } else {
        anim = body.animate([{ height: body.offsetHeight + 'px', paddingBottom: pad, opacity: 1 }, { height: '0px', paddingBottom: '0px', opacity: 0 }],
          { duration: 240, easing: 'ease-in' });
        anim.onfinish = function () { anim = null; d.open = false; body.style.overflow = ''; };
      }
    });
  }

  function init(scope) {
    var el = scope && scope.querySelectorAll ? scope : document;
    el.querySelectorAll('[data-eg-offer]').forEach(initOffer);
    el.querySelectorAll('[data-eg-carousel]').forEach(initCarousel);
    el.querySelectorAll('[data-eg-tabs]').forEach(initTabs);
    el.querySelectorAll('[data-eg-sticky]').forEach(initSticky);
    el.querySelectorAll('[data-eg-glow]').forEach(initGlow);
    el.querySelectorAll('[data-eg-stage]').forEach(initStage);
    el.querySelectorAll('[data-eg-therapies]').forEach(initTherapies);
    el.querySelectorAll('[data-eg-more]').forEach(initMore);
    el.querySelectorAll('[data-eg-save]').forEach(initSave);
    el.querySelectorAll('[data-eg-map]').forEach(initMap);
    el.querySelectorAll('.eg-cmp-wrap').forEach(initCompare);
    el.querySelectorAll('.eg-faq__item').forEach(initFaq);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* Theme editor: a section that is re-drawn gets its behaviour back. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
